// src/components/DuckBillCatfish.jsx
import React, { useRef, useEffect } from 'react';
import '../../../css/swim.css';

export default function SwimmingDuckBillCatfish({
  width = 100,
  swimDuration = '60s',
  tailDuration = '0.8s',
  minTop = 50,
  maxTop = 60,
  onClick,
  highlight = false,
  zIndex = 1,
}) {
  const wrapperRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const w = wrapperRef.current;
    const img = imgRef.current;
    if (!w || !img) return;

    // Support reversed ranges
    const low = Math.min(minTop, maxTop);
    const high = Math.max(minTop, maxTop);
    const top = low + Math.random() * (high - low);

    // Position & animate the wrapper (horizontal swim)
    w.style.top = `${top}%`;
    w.style.left = '0';
    w.style.animationDuration = swimDuration;
    w.style.width = `${width}px`;      // snug hitbox for highlight ring
    w.style.zIndex = String(zIndex);   // layer control

    // Animate the image (tail wag)
    img.style.animationDuration = tailDuration;
  }, [swimDuration, tailDuration, minTop, maxTop, width, zIndex]);

  const url = '/images/animals/50_80m/predator/duckbill_catfish_head.png';

  const handleKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      ref={wrapperRef}
      className={`swim-boto-wrapper ${
        highlight ? 'inline-block ring-4 ring-yellow-300 rounded-full scale-110' : ''
      }`}
      style={{ position: 'absolute' }}   // pointer-events: auto by default
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label="Duck-Bill Catfish"
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <img
        ref={imgRef}
        src={url}
        alt="Duck-Bill Catfish"
        className="swim-boto-img"
        draggable={false}
        style={{
          width: `${width}px`,
          display: 'block',
          cursor: onClick ? 'pointer' : 'default',
        }}
        onError={(e) =>
          console.warn('[DuckBillCatfish] image failed to load:', e.currentTarget.src)
        }
      />
    </div>
  );
}
